export default __webpack_public_path__ + "static/media/madjigglypuff.045e30e4.png";